import React from "react";
import { Badge } from "@/components/ui/badge";
import { MapPin } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const suburbs = ["Gorokan", "Wadalba", "Hamlyn Terrace", "Woongarrah", "Tuggerawong", "Toukley", "Noraville", "Norah Head", "Charmhaven", "Jilliby", "Lisarow", "Kanwal"];
export default function ServiceTerritory() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="service-territory" className="dark bg-background text-foreground relative py-24 overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1572292/img/central_coast_satellite_map.png)] opacity-40 grayscale mix-blend-luminosity" />
        {}
        <div className="absolute inset-0 bg-background/85 backdrop-blur-[2px]" />
        {}
        <div className="absolute inset-0 bg-gradient-to-b from-background via-transparent to-background" />
      </div>

      <div className="container relative z-10 mx-auto px-4">
        <div ref={ref} className={cn("max-w-4xl mx-auto text-center transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <div className="mb-12 space-y-4">
            <div className="inline-flex items-center justify-center p-3 rounded-full bg-primary/10 mb-4">
              <MapPin className="w-8 h-8 text-primary" />
            </div>
            <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-white">
              We've got the Coast covered.
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              From the peninsula to the lakes, our team provides reliable property maintenance across the entire Central Coast region.
            </p>
          </div>

          {}
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
            {suburbs.map((suburb, i) => <div key={suburb} data-index={i} className={cn("transition-all duration-500", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4")} style={{
            transitionDelay: `${i * 30}ms`
          }}>
                <Badge variant="outline" className="w-full justify-center py-2.5 text-sm md:text-base border-primary/20 bg-background/50 hover:bg-primary/10 hover:border-primary/50 hover:text-primary transition-colors cursor-default backdrop-blur-sm">
                  {suburb}
                </Badge>
              </div>)}
          </div>

          <div className="mt-12 pt-8 border-t border-border/50">
            <p className="text-sm text-muted-foreground">
              Don't see your suburb? <span className="text-primary font-medium">Contact us</span> to check availability.
            </p>
          </div>
        </div>
      </div>
    </section>;
}